import * as React from "react"
export const Svg_051 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M52.37 56.958V59H59v-6.63h-2.042a4.593 4.593 0 0 0-4.588 4.588Z"
      />
      <path
        fill="url(#c)"
        d="M2.042 52.37H0V59h6.63v-2.042a4.593 4.593 0 0 0-4.588-4.588Z"
      />
      <path
        fill="url(#d)"
        d="M56.958 29.804H59v-6.63h-6.63v2.043a4.593 4.593 0 0 0 4.588 4.587Z"
      />
      <path
        fill="url(#e)"
        d="M6.63 25.217v-2.043H0v6.63h2.042a4.592 4.592 0 0 0 4.588-4.587Z"
      />
      <path
        fill="url(#f)"
        d="M56.958 33.261c-4.436 0-8.045-3.609-8.045-8.044v-2.043H31.226l.004-6.353h.553c4.74 0 8.596-3.856 8.596-8.596V0h-4.014A8.588 8.588 0 0 0 29.5 3.428 8.588 8.588 0 0 0 22.635 0h-4.014v8.225c0 4.74 3.856 8.596 8.596 8.596h.556l-.004 6.353H10.087v2.043c0 4.436-3.609 8.044-8.045 8.044H0v15.652h2.042c4.436 0 8.045 3.61 8.045 8.045V59h38.826v-2.042c0-4.436 3.609-8.045 8.045-8.045H59V33.261h-2.042ZM17.34 42.816h-3.457v-3.457h3.457v3.457Zm11.5-3.457h1.319a5.27 5.27 0 0 1 5.263 5.263 5.273 5.273 0 0 1-4.195 5.155v2.309h-3.457v-2.239a4.815 4.815 0 0 1-4.195-4.769h3.457c0 .745.606 1.351 1.351 1.351h1.776c.996 0 1.807-.81 1.807-1.807 0-.996-.81-1.806-1.807-1.806h-1.32a5.27 5.27 0 0 1-5.264-5.264 5.273 5.273 0 0 1 4.195-5.155v-2.309h3.457v2.239a4.815 4.815 0 0 1 4.195 4.769h-3.457c0-.745-.605-1.35-1.35-1.35H28.84c-.996 0-1.807.81-1.807 1.806s.811 1.807 1.807 1.807Zm16.274 3.457h-3.457v-3.457h3.457v3.457Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={53.903}
        x2={57.053}
        y1={53.365}
        y2={58.461}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={1.533}
        x2={4.682}
        y1={53.365}
        y2={58.461}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={53.903}
        x2={57.053}
        y1={24.169}
        y2={29.265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={1.533}
        x2={4.682}
        y1={24.169}
        y2={29.265}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={13.644}
        x2={41.669}
        y1={8.85}
        y2={54.206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)